import { render } from "./device-disabled.vue?vue&type=template&id=48740004"
const script = {}

import "./device-disabled.vue?vue&type=style&index=0&id=48740004&lang=sass"
script.render = render

export default script